import moment from 'moment';

import type Paginated from '../../core/paginable';
import { useGetApplication } from '../../hooks';

import {
  type Collection,
  type CollectionStatistics,
  type CollectionTaxpayer,
  type Communication,
  type DebTaxpayer,
  type Indicators,
  type InfoTaxreturnsAndPayments,
  type StatisticsRequest
} from './types';

export const baseUrlCollection = 'Collections';
export const baseUrlCollectionTaxpayers = 'CollectionTaxpayers';

export const useGetCollectionsTaxpayers = (taxId: string, maxNumberOfTaxpayers: number) => {
  const result = useGetApplication<Array<CollectionTaxpayer>>({
    url: `${baseUrlCollection}/taxpayers?taxId=${taxId}&maximumNumberOfTaxpayers=${maxNumberOfTaxpayers}`,
    params: undefined
  });

  return result;
};

export const useGetCollection = (id: string) => {
  const newId = id ? id : 'c2669cec-d7d3-479e-906e-479733354628';
  const [{ data, loading, error }] = useGetApplication<Paginated<Collection>>({
    url: baseUrlCollection,
    params: { page: 1, pageSize: 1, id: newId }
  });

  const [collection] = data?.data || [];

  const rewriteCollection = collection
    ? {
        ...collection,
        startDate: moment(collection.startDate).toDate(),
        endDate: moment(collection.endDate).toDate()
      }
    : undefined;
  return { loading, error, data: rewriteCollection };
};

export const useGetCollectionTaxpayer = (id: string) => {
  const [{ data, loading, error }] = useGetApplication<Paginated<DebTaxpayer>>({
    url: `${baseUrlCollectionTaxpayers}`,
    params: { page: 1, pageSize: 1, id: id }
  });
  const [taxpayer] = data?.data || [];

  return { data: taxpayer, loading, error };
};

export const useGetInfoCollectionTaxpayer = (taxpayerId: string, limit = 5) => {
  const id = taxpayerId ? taxpayerId : 'c2669cec-d7d3-479e-906e-479733354628';
  return useGetApplication<Array<InfoTaxreturnsAndPayments>>({
    url: `${baseUrlCollectionTaxpayers}/taxreturns-and-Payments`,
    params: { maxNumberOfTaxreturn: limit, maxNumberOfPayments: limit, taxpayerId: id }
  });
};

export const useGetCommunications = (id: string, page: number, pageSize: number) => {
  const result = useGetApplication<Paginated<Communication>>({
    url: `${baseUrlCollectionTaxpayers}`,
    params: { page, pageSize, id: id }
  });
  return result;
};

export const useGetIndicators = (collectionTaxpayerId: string) => {
  const result = useGetApplication<Indicators>({
    url: `${baseUrlCollectionTaxpayers}/indicators`,
    params: { collectionTaxpayerId }
  });
  return result;
};

export const useGetStatistics = (request: StatisticsRequest) => {
  const result = useGetApplication<CollectionStatistics>({
    url: `collections/statistics`,
    params: request
  });
  return result;
};

// export const useGetOmissionsTaxpayer = (taxpayerId: string) => {
//   const [state] = useState({});
//   const id = taxpayerId ? taxpayerId : 'c2669cec-d7d3-479e-906e-479733354628';
//
//   return useGetApplication<OmissionsByTax[]>({
//     url: `${BaseUrlTaxpayer}/${id}/omissions`,
//     params: state
//   });
// };
